import { api } from '../../../App';
import { FormInfo } from '../../../model/FormInfo';
import { parseFormInfo } from '../../../parsers/formInfo.parser';

export const getDoctorFormInfo = async (): Promise<FormInfo> => {
  const response = await api.forms.apiFormInfoDoctorRegistrationGet();
  return parseFormInfo(response.data);
};
